export default __webpack_public_path__ + "static/media/cloud-1.20c29ba2.webp";